import React, { useState, useEffect } from 'react';
import './infographic.scss';
import infographicD from '../../Assets/infographicD.svg';
import infographicM from '../../Assets/infographicM.svg';

const Infographic = () => {
  const [width, setWidth] = useState();

  useEffect(() => {
    const handleWindowResize = () => setWidth(window.innerWidth);
    window.addEventListener('resize', handleWindowResize);

    return () => window.removeEventListener('resize', handleWindowResize);
  }, []);

  return (
    <div className="infographic">
      <div className="infographic__sepBar" />
      <div className="infographic__heading">
        <h4>Fresh Data from Field to Fork</h4>
        <p>
          The Life Cycle of a Kumato<sup>®</sup>
        </p>
      </div>
      <div className="infographic__graphicCont">
        <img src={width < 815 ? infographicM : infographicD} alt="infographic" />
      </div>
    </div>
  );
};

export default Infographic;
